import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-email-contact',
  templateUrl: './email-contact.component.html',
  styleUrls: ['./email-contact.component.scss']
})
export class EmailContactComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/home/pages/Dashboard/AdminDashboardPages/System settings/email-contact/email-contact.component.ts